import React from 'react';
import styled, { keyframes } from 'styled-components';
import PropTypes from 'prop-types';

const rotate = keyframes`
  from { transform: rotate(360deg); }
  to { transform: rotate(0deg); }
`;

const Circle = styled.svg`
  position: absolute;
  z-index: 10;
  top: ${props => props.top};
  left: ${props => props.left};
  animation: ${rotate} 40s linear infinite;
  transform-origin: center center;
  path {
    fill: transparent;
    stroke: transparent;
  }
  text {
    ${props => props.theme.fluidType( -1 )};
    font-family: "DM Sans", sans-serif;
    fill: ${props => props.theme.colours.black};
    text-align: justify;
    text-transform: uppercase;
    font-weight: 700;
  }
`;

function CircleText({text, length, top, left}) {
  return (
    <Circle viewBox="0 0 150 150" width="150" height="150" top={top} left={left}>
      <path id="circle"
        d="
                M 75 75
                m -60, 0
                a 60,60 0 1,1 120,0
                a 60,60 0 1,1 -120,0
                "
      />
      <text width="150" textLength={`${length}%`}>
        <textPath xlinkHref="#circle" textLength={`${length}%`}>{text}</textPath>
      </text>
    </Circle>
  )
}

CircleText.propTypes = {
  text: PropTypes.string.isRequired,
  length: PropTypes.number,
  top: PropTypes.string,
  left: PropTypes.string,
};

CircleText.defaultProps = {
  length: 240,
  top: '0',
  left: '0',
};

export default CircleText;
